import PropTypes from 'prop-types';

export default function ExpectedCompTable({ compositions }) {
  return (
    <div className='index-table-cur-comp-wrapper mb-15' dir={"rtl"}>
      <table className='index-table-cur-comp' cellSpacing="0" rules="all" border="1">
        <thead>
          <tr align="justify">
            <th scope="col" align="center" className='index-table-th-blue'>Exchange</th>
            <th scope="col" align="center" className='index-table-th-blue'>Ticker-Region</th>
            <th scope="col" align="center" className='index-table-th-blue'>Name</th>
            <th scope="col" align="center" className='index-table-th-blue'>#</th>
          </tr>
        </thead>
        <tbody>
          {
            compositions.map((row,i) => (
              // if 'update_status' in row and it is not 'deleted' then skip this row
              row?.update_status !== 'deleted' && (
                <tr key={row.isin}>
                  <td align="center">{row.exchange}</td>
                  <td align="center">{row?.ticker_region || row?.exchange_asset_id || ""}</td>
                  <td align="left">{row.asset_name}</td>
                  <td align="center" style={{width:'30px'}}>{i + 1}</td>
                </tr>
              )
            ))
          }
        </tbody>
      </table>
    </div>
  )
}

ExpectedCompTable.propTypes = {
  compositions: PropTypes.arrayOf(PropTypes.shape({
    isin: PropTypes.string.isRequired,
    exchange: PropTypes.string.isRequired,
    ticker_region: PropTypes.string,
    exchange_asset_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    asset_name: PropTypes.string.isRequired,
  })).isRequired,
};